module.exports = __webpack_public_path__ + "img/5_no.d2e524be.svg";